var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datarows-viewer',{ref:"datarowsViewer",attrs:{"fields":_vm.fields,"api-url":_vm.url,"api-headers":_vm.headers,"api-extra-payloads":_vm.parameters}},[_c('span',{attrs:{"slot":"header"},slot:"header"})])}
var staticRenderFns = []

export { render, staticRenderFns }